import React, { useState, useEffect } from 'react'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import PowerBI from '../assets/PowerBI.png'


const Artikler = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 9;

    const techs = [
        {
            id: 1,
            src: PowerBI,
            path: '/PowerBI-articles/TheDashboard'
        }
        
    ].filter(Boolean); // Remove undefined entries from extra commas

    const totalPages = Math.ceil(techs.length / itemsPerPage);
    
    const getCurrentPageItems = () => {
        const start = currentPage * itemsPerPage;
        return techs.slice(start, start + itemsPerPage);
    };

    const nextPage = () => {
        if (currentPage < totalPages - 1) setCurrentPage(curr => curr + 1);
    };

    const prevPage = () => {
        if (currentPage > 0) setCurrentPage(curr => curr - 1);
    };

    return (
        <motion.div 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            name='Artikler' 
            className='bg-gradient-to-b from-white to-white w-full text-black min-h-screen py-32 mt-96 mb-32 sm:mb-0 sm:mt-0 sm:py-20'
        >
            <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className='pb-8 flex items-center justify-between'
                >
                    <p className='text-4xl font-bold inline border-b-4 border-black'>Articles</p>
                    <div className='flex gap-4 items-center'>
                        <button onClick={prevPage} className='p-2 hover:scale-110 duration-200'>
                            <FaArrowLeft size={20} />
                        </button>
                        <span>{currentPage + 1}/{totalPages}</span>
                        <button onClick={nextPage} className='p-2 hover:scale-110 duration-200'>
                            <FaArrowRight size={20} />
                        </button>
                    </div>
                </motion.div>

                <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0'>
                    {getCurrentPageItems().map(({ id, src, path }, index) => (
                        <motion.div
                            key={id}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.7 }}
                            className='rounded-lg'  // Removed shadow-md and border classes
                        >
                            <Link 
                                to={path}
                                onClick={() => window.scrollTo(0, 0)}
                            >
                                <img 
                                    src={src} 
                                    alt="" 
                                    className='rounded-md duration-200 hover:scale-105' 
                                />
                            </Link>
                        </motion.div>
                    ))}
                </div>
            </div>
        </motion.div>
    );
};

export default Artikler